module.exports = __webpack_public_path__ + "media/components/footer/static/location-fe5ed19ee05e19517c004c4d61ecec14.png";